export const TIPO_USUARIO = {
    Franqueador: 0,
    Colaborador: 1,
    Protetico: 2
}